  $("#announcement_hero_image").change(function(){
    console.log("Change in file");

    $('#img_prev').removeClass('d-none');
    readURL(this);
  });

  $("#announcement_hero_image").change(function(){
    console.log("Change in file");

    $('#img_prev').removeClass('d-none');
    $('#img_icon').addClass('d-none');
    readURL(this);
  });

function readURL(input) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();

    reader.onload = function (e) {
      $('#img_prev').attr('src', e.target.result);
      console.log("Setting the image source");
    }
    reader.readAsDataURL(input.files[0]);
  }
}
